import React, { useState } from 'react';
import { Table, TableBody, TableHead, Paper, Grid, TextField, Button, IconButton, TableRow, TableCell, Tooltip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { withRouter } from 'react-router';
import MomentUtils from '@date-io/moment';
import { backendDateFormat, displayDateFormatShort } from '../../../constants';
import { onCheckFormPermission } from '../../../utils_v2';
import { CkEditorText } from '../../../shared_elements';
import { regexConstants } from '../../../constants/regEx';

const yesNoOptions = ['Yes', 'No'];
const limitTypeOptions = ['FH Limit', 'FC Limit', 'Calender', 'N/A'];
const trendMonitoringOptions = ['Operator', 'OEM'];

const genRowId = () => Math.floor(Math.random() * 90000) + 10;

const newShopVisitRow = () => ({ previous_shop_visits: '', qualifying_sv: null, date: null, csn_at_induction: '', deltedId: genRowId() });
const newTaskRow = () => ({ task: '', fc_limit: '', fh_limit: '', calendar_interval: '', deltedId: genRowId() });
const newLimiterRow = () => ({ limited_by: '', expected_date: null, tsn: '', csn: '', egtm: '', llp_limit: '', ctg: '', deltedId: genRowId() });

function MaintenancePlanningV2({ data, setData, onFieldChange, callthisapi, getResponseBack, currentFormDetail, setLoading, isLoading, setFormSave, formSave }) {
    const isEditing = formSave?.type === 'maintenance_planning';
    const isDisabled = !onCheckFormPermission(currentFormDetail) || !isEditing;
    const mp = data?.maintenance_planning || {};

    const onChangeField = (key, value, nestedParam) => {
        onFieldChange('', key, value, 'maintenance_planning', '', '', nestedParam);
    };

    const addRow = (arrayKey, factory) => {
        setData(prev => ({
            ...prev,
            maintenance_planning: {
                ...prev?.maintenance_planning,
                [arrayKey]: [...(prev?.maintenance_planning?.[arrayKey] || []), factory()]
            }
        }));
    };

    const updateRow = (arrayKey, index, field, value) => {
        setData(prev => {
            const rows = [...(prev?.maintenance_planning?.[arrayKey] || [])];
            rows[index] = { ...(rows[index] || {}), [field]: value };
            return { ...prev, maintenance_planning: { ...prev?.maintenance_planning, [arrayKey]: rows } };
        });
    };

    const removeRow = (arrayKey, index) => {
        setData(prev => {
            const rows = [...(prev?.maintenance_planning?.[arrayKey] || [])];
            rows.splice(index, 1);
            return { ...prev, maintenance_planning: { ...prev?.maintenance_planning, [arrayKey]: rows } };
        });
    };

    return (
        <section className='form-t015'>
            <Paper square style={{ padding: '10px', marginBottom: '5px' }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'><h4>4. Maintenance Planning :</h4></li>
                    <li className='list-inline-item' style={{ float: 'right' }}>
                        {!(isEditing && formSave?.open) && (
                            <Tooltip title="Edit" placement="top">
                                <IconButton disabled={!onCheckFormPermission(currentFormDetail) || formSave?.isdisabled} style={{ cursor: 'pointer' }} color="primary" size="small" onClick={() => setFormSave({ open: true, type: 'maintenance_planning', isdisabled: true })} > <EditIcon /> </IconButton>
                            </Tooltip>
                        )}
                        {isEditing && (
                            <>
                                <Tooltip title="Cancel" placement="top">
                                    <Button style={{ marginInline: '5px' }} variant="outlined" color="primary" onClick={() => { getResponseBack(); setFormSave({ open: false, type: '', isdisabled: false }); }} size="small" > Cancel </Button>
                                </Tooltip>
                                <Tooltip title="Save" placement="top">
                                    <Button variant="contained" color="primary" onClick={() => { callthisapi('', data); setFormSave({ open: false, type: '', isdisabled: false }); }} size="small" > Save </Button>
                                </Tooltip>
                            </>
                        )}
                    </li>
                </ul>

                <h5 style={{ margin: '10px 0px' }}>4.1 Shop visit information</h5>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <span>For</span>
                        <TextField variant='outlined' disabled value={data?.operator_id || ''} placeholder="Enter" size='small' style={{ verticalAlign: 'middle', marginLeft: '5px', width: '200px' }} />
                        <span className='span-style'>the fleet average cycles between Shop Visits for this engine model is</span>
                        <TextField
                            disabled={isDisabled}
                            variant='outlined'
                            size='small'
                            placeholder="Enter.."
                            value={mp?.esn_fc_to_go || ''}
                            onChange={(e) => { onChangeField('esn_fc_to_go', e.target.value ? e.target.value : null) }}
                            inputProps={{ maxLength: 10 }}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '120px' }}
                        />
                        <span className='span-style'>For ESN</span>
                        <TextField
                            disabled={isDisabled}
                            variant='outlined'
                            size='small'
                            placeholder="Enter.."
                            value={mp?.fleet_avg_cycles_between_sv || ''}
                            onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onChangeField('fleet_avg_cycles_between_sv', e.target.value ? e.target.value : null) : e.preventDefault() }}
                            inputProps={{ maxLength: 10 }}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '120px' }}
                        />
                        <span className='span-style'>FC to go.</span>
                    </Grid>
                    <Grid item xs={12}>
                        <span>The predicted Shop Visit interval for</span>
                        <TextField variant='outlined' disabled value={data?.operator_id || ''} placeholder="Enter" size='small' style={{ verticalAlign: 'middle', marginLeft: '5px', width: '200px' }} />
                        <span className='span-style'>operating with </span>
                        <TextField
                            disabled
                            variant='outlined'
                            size='small'
                            placeholder="Enter.."
                            value={data?.current_tr || ''}
                            inputProps={{ maxLength: 10 }}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '120px' }}
                        />
                        <span className='span-style'>is </span>
                        <TextField
                            disabled={isDisabled}
                            variant='outlined'
                            size='small'
                            placeholder="Enter.."
                            value={mp?.predicted_sv_interval_fc_to_go || ''}
                            onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onChangeField('predicted_sv_interval_fc_to_go', e.target.value ? e.target.value : null) : e.preventDefault() }}
                            inputProps={{ maxLength: 10 }}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '120px' }}
                        />
                        <span className='span-style'>FC to go.</span>
                    </Grid>
                    <Grid item xs={12}>
                        <span>The next Shop Visit for ESN</span>
                        <TextField variant='outlined' disabled value={currentFormDetail?.asset?.asset_type === 1 ? currentFormDetail?.asset?.msn : currentFormDetail?.asset?.esn || ''} placeholder="Enter" size='small' style={{ verticalAlign: 'middle', marginLeft: '5px', width: '150px' }} />
                        <span className='span-style'>is planned by</span>
                        <TextField variant='outlined' disabled value={data?.operator_id || ''} placeholder="Enter" size='small' style={{ verticalAlign: 'middle', marginLeft: '5px', width: '200px' }} />
                        <span className='span-style'>in</span>
                        <TextField
                            disabled={isDisabled}
                            variant='outlined'
                            size='small'
                            placeholder="Enter.."
                            value={mp?.next_sv_planned_fc_to_go || ''}
                            onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? onChangeField('next_sv_planned_fc_to_go', e.target.value ? e.target.value : null) : e.preventDefault() }}
                            inputProps={{ maxLength: 10 }}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '120px' }}
                        />
                        <span className='span-style'>FC to go.</span>
                    </Grid>
                </Grid>

                <ul className='list-inline'>
                    <li className="list-inline-item"><h6 style={{ margin: '10px 0px 5px' }}>Previous Shop Visits</h6></li>
                    <li className="list-inline-item" style={{ float: 'right' }}>
                        <Button disabled={!isEditing || !onCheckFormPermission(currentFormDetail)} onClick={() => addRow('previous_shop_visits', newShopVisitRow)} color="primary" variant="contained" size="small" style={{ margin: '5px' }} >+ ADD</Button>
                    </li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableHead className='table-align-head'>
                        <TableRow>
                            <TableCell><h6>SV#</h6></TableCell>
                            <TableCell><h6>Previous Shop Visits</h6></TableCell>
                            <TableCell><h6>Qualifying SV</h6></TableCell>
                            <TableCell><h6>Date</h6></TableCell>
                            <TableCell><h6>CSN at induction</h6></TableCell>
                            <TableCell><h6>Action</h6></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mp?.previous_shop_visits?.map((item, index) => (
                            <TableRow key={item?.id || item?.deltedId}>
                                <TableCell style={{ textAlignLast: 'center' }}>{item?.sv_number || `SV${index + 1}`}</TableCell>
                                <TableCell>
                                    <TextField disabled={isDisabled} variant='outlined' fullWidth placeholder="Enter.." value={item?.previous_shop_visits || ''} onChange={(e) => updateRow('previous_shop_visits', index, 'previous_shop_visits', e.target.value)} inputProps={{ maxLength: 250 }} />
                                </TableCell>
                                <TableCell>
                                    <Autocomplete
                                        disabled={isDisabled}
                                        options={yesNoOptions}
                                        getOptionLabel={option => option}
                                        value={yesNoOptions.filter(option => option === item?.qualifying_sv)[0] || null}
                                        onChange={(e, value) => updateRow('previous_shop_visits', index, 'qualifying_sv', value)}
                                        renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' />}
                                    />
                                </TableCell>
                                <TableCell width='180'>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            disabled={isDisabled}
                                            margin="normal"
                                            format={displayDateFormatShort}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            value={item?.date || null}
                                            onChange={(date) => updateRow('previous_shop_visits', index, 'date', date ? moment(date).format(backendDateFormat) : null)}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </TableCell>
                                <TableCell>
                                    <TextField disabled={isDisabled} variant='outlined' fullWidth placeholder="Enter.." value={item?.csn_at_induction || ''} onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? updateRow('previous_shop_visits', index, 'csn_at_induction', e.target.value) : e.preventDefault() }} inputProps={{ maxLength: 10 }} />
                                </TableCell>
                                <TableCell align='center'>
                                    <Tooltip title='Delete' arrow>
                                        <IconButton disabled={!isEditing || !onCheckFormPermission(currentFormDetail)} color='secondary' onClick={() => removeRow('previous_shop_visits', index)}>
                                            <DeleteOutlinedIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <h5 style={{ margin: '10px 0px' }}>4.2 Operator Maintenance Planning :</h5>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <span>There is a copy of the</span>
                        <TextField variant='outlined' disabled value={data?.operator_id || ''} placeholder="Enter" size='small' style={{ verticalAlign: 'middle', marginLeft: '5px', width: '200px' }} />
                        <span className='span-style'>specific AMP / MPD available.</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={yesNoOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                            value={yesNoOptions.filter(option => option === mp?.has_specific_amp_mpd)[0] || null}
                            onChange={(e, value) => onChangeField('has_specific_amp_mpd', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <span>The</span>
                        <TextField variant='outlined' disabled value={data?.operator_id || ''} placeholder="Enter" size='small' style={{ verticalAlign: 'middle', marginLeft: '5px', width: '200px' }} />
                        <span className='span-style'>AMP / MPD deviates from OEM recommended intervals.</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={yesNoOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                            value={yesNoOptions.filter(option => option === mp?.amp_mpd_deviates_from_oem)[0] || null}
                            onChange={(e, value) => onChangeField('amp_mpd_deviates_from_oem', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <CkEditorText
                            placeholder='If yes, please enter details, otherwise Enter.. "N/A"'
                            disabled={isDisabled || isLoading}
                            htmlData={mp?.amp_mpd_deviation_details || ''}
                            onChangeData={(value) => onChangeField('amp_mpd_deviation_details', value)}
                        />
                    </Grid>
                </Grid>

                <ul className='list-inline'>
                    <li className="list-inline-item"><h6 style={{ margin: '10px 0px 5px' }}>Specific Tasks</h6></li>
                    <li className="list-inline-item" style={{ float: 'right' }}>
                        <Button disabled={!isEditing || !onCheckFormPermission(currentFormDetail)} onClick={() => addRow('specific_tasks', newTaskRow)} color="primary" variant="contained" size="small" style={{ margin: '5px' }} >+ ADD</Button>
                    </li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableHead className='table-align-head'>
                        <TableRow>
                            <TableCell><h6>Specific Tasks</h6></TableCell>
                            <TableCell><h6>FC limit</h6></TableCell>
                            <TableCell><h6>FH limit</h6></TableCell>
                            <TableCell><h6>Calendar interval</h6></TableCell>
                            <TableCell><h6>Action</h6></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mp?.specific_tasks?.map((item, index) => (
                            <TableRow key={item?.id || item?.deltedId}>
                                <TableCell>
                                    <TextField disabled={isDisabled} variant='outlined' fullWidth placeholder="Enter.." value={item?.task || ''} onChange={(e) => updateRow('specific_tasks', index, 'task', e.target.value)} inputProps={{ maxLength: 250 }} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled={isDisabled} variant='outlined' fullWidth placeholder="Enter.." value={item?.fc_limit || ''} onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? updateRow('specific_tasks', index, 'fc_limit', e.target.value) : e.preventDefault() }} inputProps={{ maxLength: 10 }} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled={isDisabled} variant='outlined' fullWidth placeholder="Enter.." value={item?.fh_limit || ''} onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? updateRow('specific_tasks', index, 'fh_limit', e.target.value) : e.preventDefault() }} inputProps={{ maxLength: 10 }} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled={isDisabled} variant='outlined' fullWidth placeholder="Enter.." value={item?.calendar_interval || ''} onChange={(e) => updateRow('specific_tasks', index, 'calendar_interval', e.target.value)} inputProps={{ maxLength: 100 }} />
                                </TableCell>
                                <TableCell align='center'>
                                    <Tooltip title='Delete' arrow>
                                        <IconButton disabled={!isEditing || !onCheckFormPermission(currentFormDetail)} color='secondary' onClick={() => removeRow('specific_tasks', index)}>
                                            <DeleteOutlinedIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <Grid container spacing={1} style={{ marginTop: '10px' }}>
                    <Grid item xs={12}>
                        <TextField variant='outlined' disabled value={data?.operator_id || ''} placeholder="Enter" size='small' style={{ verticalAlign: 'middle', width: '200px' }} />
                        <span className='span-style'>maintains ETOPS configuration for this engine.</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={yesNoOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                            value={yesNoOptions.filter(option => option === mp?.maintains_etops_configuration)[0] || null}
                            onChange={(e, value) => onChangeField('maintains_etops_configuration', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField variant='outlined' disabled value={data?.operator_id || ''} placeholder="Enter" size='small' style={{ verticalAlign: 'middle', width: '200px' }} />
                        <span className='span-style'>uses derate, with a fleet average percentage of</span>
                        <TextField
                            disabled={isDisabled}
                            variant='outlined'
                            size='small'
                            placeholder="Enter.."
                            value={mp?.derate_fleet_avg_percentage || ''}
                            onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onChangeField('derate_fleet_avg_percentage', e.target.value ? e.target.value : null) : e.preventDefault() }}
                            inputProps={{ maxLength: 10 }}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '100px' }}
                        />
                        <span>%.</span>
                    </Grid>
                    <Grid item xs={12}>
                        <span>Engine trend monitoring is managed by the</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={trendMonitoringOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '140px' }}
                            value={trendMonitoringOptions.filter(option => option === mp?.engine_trend_monitoring_managed_by)[0] || null}
                            onChange={(e, value) => onChangeField('engine_trend_monitoring_managed_by', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style'>.</span>
                    </Grid>
                    <Grid item xs={12}>
                        <span>Lessee has granted SAEL access to applicable ECM data through OEM portal.</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={yesNoOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                            value={yesNoOptions.filter(option => option === mp?.ecm_portal_access_granted)[0] || null}
                            onChange={(e, value) => onChangeField('ecm_portal_access_granted', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                    </Grid>
                </Grid>

                <h6 style={{ margin: '10px 0px 5px' }}>
                    <TextField variant='outlined' disabled value={data?.operator_id || ''} placeholder="Enter" size='small' style={{ verticalAlign: 'middle', width: '200px', marginRight: '5px' }} />
                    has the following Shop Visit drivers and intervals in their fleet:
                </h6>
                <CkEditorText
                    placeholder='Enter..'
                    disabled={isDisabled || isLoading}
                    htmlData={mp?.sv_drivers_intervals_notes || ''}
                    onChangeData={(value) => onChangeField('sv_drivers_intervals_notes', value)}
                />

                <div style={{ marginTop: '10px' }}>
                    <span>Other relevant Shop Visit info (FHA/FMP, PAYG/PASV, workscoping, estimated costs, etc.) for</span>
                    <TextField variant='outlined' disabled value={data?.operator_id || ''} placeholder="Enter" size='small' style={{ verticalAlign: 'middle', marginLeft: '5px', width: '200px' }} />
                    <CkEditorText
                        placeholder='Enter..'
                        disabled={isDisabled || isLoading}
                        htmlData={mp?.other_sv_info_notes || ''}
                        onChangeData={(value) => onChangeField('other_sv_info_notes', value)}
                    />
                </div>

                <h5 style={{ margin: '10px 0px' }}>4.3 General comments on Maintenance Planning:</h5>
                <CkEditorText
                    placeholder='Enter..'
                    disabled={isDisabled || isLoading}
                    htmlData={mp?.general_comments || ''}
                    onChangeData={(value) => onChangeField('general_comments', value)}
                />

                <h5 style={{ margin: '10px 0px' }}>4.4 Factors that may reduce TOW other than LLPs or Performance :</h5>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <span>The engine is limited by an Airworthiness Directive.</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={yesNoOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                            value={yesNoOptions.filter(option => option === mp?.ad_limited)[0] || null}
                            onChange={(e, value) => onChangeField('ad_limited', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <CkEditorText
                            placeholder='Enter..'
                            disabled={isDisabled || isLoading}
                            htmlData={mp?.ad_notes || ''}
                            onChangeData={(value) => onChangeField('ad_notes', value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <span className='span-style'>Limit type</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={limitTypeOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '140px' }}
                            value={limitTypeOptions.filter(option => option === mp?.ad_limit_type)[0] || null}
                            onChange={(e, value) => onChangeField('ad_limit_type', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style' style={{ marginLeft: '10px' }}>Limit value</span>
                        <TextField
                            disabled={isDisabled}
                            variant='outlined'
                            size='small'
                            placeholder='Enter'
                            inputProps={{ maxLength: 10 }}
                            value={mp?.ad_limit_value || ''}
                            onChange={(e) => onChangeField('ad_limit_value', e.target.value)}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '150px' }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} style={{ marginTop: '10px' }}>
                        <span>The engine is limited by reduced interval inspections as result of BSI findings.</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={yesNoOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                            value={yesNoOptions.filter(option => option === mp?.bsi_limited)[0] || null}
                            onChange={(e, value) => onChangeField('bsi_limited', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <CkEditorText
                            placeholder='Enter..'
                            disabled={isDisabled || isLoading}
                            htmlData={mp?.bsi_notes || ''}
                            onChangeData={(value) => onChangeField('bsi_notes', value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <span className='span-style'>Limit type</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={limitTypeOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '140px' }}
                            value={limitTypeOptions.filter(option => option === mp?.bsi_limit_type)[0] || null}
                            onChange={(e, value) => onChangeField('bsi_limit_type', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style' style={{ marginLeft: '10px' }}>Limit value</span>
                        <TextField
                            disabled={isDisabled}
                            variant='outlined'
                            size='small'
                            placeholder='Enter'
                            inputProps={{ maxLength: 10 }}
                            value={mp?.bsi_limit_value || ''}
                            onChange={(e) => onChangeField('bsi_limit_value', e.target.value)}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '150px' }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} style={{ marginTop: '10px' }}>
                        <span>The engine is limited by another reason which may cause premature removal.</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={yesNoOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '110px' }}
                            value={yesNoOptions.filter(option => option === mp?.other_limited)[0] || null}
                            onChange={(e, value) => onChangeField('other_limited', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <CkEditorText
                            placeholder='Enter..'
                            disabled={isDisabled || isLoading}
                            htmlData={mp?.other_notes || ''}
                            onChangeData={(value) => onChangeField('other_notes', value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <span className='span-style'>Limit type</span>
                        <Autocomplete
                            disabled={isDisabled}
                            options={limitTypeOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', marginLeft: '5px', width: '140px' }}
                            value={limitTypeOptions.filter(option => option === mp?.other_limit_type)[0] || null}
                            onChange={(e, value) => onChangeField('other_limit_type', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                        <span className='span-style' style={{ marginLeft: '10px' }}>Limit value</span>
                        <TextField
                            disabled={isDisabled}
                            variant='outlined'
                            size='small'
                            placeholder='Enter'
                            inputProps={{ maxLength: 10 }}
                            value={mp?.other_limit_value || ''}
                            onChange={(e) => onChangeField('other_limit_value', e.target.value)}
                            style={{ verticalAlign: 'middle', marginLeft: '5px', width: '150px' }}
                        />
                    </Grid>
                </Grid>

                <p className='span-style' style={{ marginTop: '10px' }}>If there is a limiter applicable fill in how many Cycles To Go in below table to compare data for the next Shop Visit.</p>
                <ul className='list-inline'>
                    <li className="list-inline-item"><h6 style={{ margin: '10px 0px 5px' }}>Limiter Details</h6></li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableHead className='table-align-head'>
                        <TableRow>
                            <TableCell><h6>Limited by</h6></TableCell>
                            <TableCell><h6>Date</h6></TableCell>
                            <TableCell><h6>TSN</h6></TableCell>
                            <TableCell><h6>CSN</h6></TableCell>
                            <TableCell><h6>EGTm</h6></TableCell>
                            <TableCell><h6>LLP limit</h6></TableCell>
                            <TableCell><h6>CTG</h6></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mp?.tow_limiting_factors?.map((item, index) => (
                            <TableRow key={item?.id || item?.deltedId}>
                                <TableCell>
                                    <TextField disabled={isDisabled} variant='outlined' fullWidth placeholder="Enter.." value={item?.limited_by || ''} onChange={(e) => updateRow('tow_limiting_factors', index, 'limited_by', e.target.value)} inputProps={{ maxLength: 100 }} />
                                </TableCell>
                                <TableCell width='220'>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            disabled
                                            margin="normal"
                                            format={displayDateFormatShort}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            value={item?.expected_date || null}
                                            onChange={(date) => updateRow('tow_limiting_factors', index, 'expected_date', date ? moment(date).format(backendDateFormat) : null)}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </TableCell>
                                <TableCell>
                                    <TextField disabled variant='outlined' fullWidth placeholder="Enter.." value={item?.tsn || ''} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled variant='outlined' fullWidth placeholder="Enter.." value={item?.csn || ''} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled variant='outlined' fullWidth placeholder="Enter.." value={item?.egtm || ''} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled variant='outlined' fullWidth placeholder="Enter.." value={item?.llp_limit || ''} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled={isDisabled} variant='outlined' fullWidth placeholder="Enter.." value={item?.ctg || ''} onChange={(e) => { regexConstants.onlyNumeric.test(e.target.value) ? updateRow('tow_limiting_factors', index, 'ctg', e.target.value) : e.preventDefault() }} inputProps={{ maxLength: 10 }} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <ul className='list-inline'>
                    <li className="list-inline-item"><h5 style={{ margin: '10px 0px 5px' }}>4.5 Estimated Next Shop Visit</h5></li>
                    <li className="list-inline-item" style={{ float: 'right' }}>
                        <Autocomplete
                            disabled={isDisabled}
                            options={yesNoOptions}
                            getOptionLabel={option => option}
                            style={{ display: 'inline-grid', width: '110px' }}
                            value={yesNoOptions.filter(option => option === mp?.sv_not_applicable_engine_in_shop)[0] || null}
                            onChange={(e, value) => onChangeField('sv_not_applicable_engine_in_shop', value)}
                            renderInput={params => <TextField variant='outlined' {...params} placeholder='Not applicable - Engine currently in shop' style={{ display: 'contents' }} margin="normal" fullWidth />}
                        />
                    </li>
                </ul>
                <p className='span-style'>If the engine is in shop at time of the MLI, this section can be marked as 'not-applicable'.</p>
                <p className='span-style'>The intent of the following table is to project the expected values for the next Shop Visit, based on the data available at time of inspection and FH/FC ratio based on the average monthly utilization. The expected values are for reference only.</p>

                <h6 style={{ margin: '10px 0px 5px' }}>Expected Values</h6>
                <Table className='mui-table-format-t015'>
                    <TableHead className='table-align-head'>
                        <TableRow>
                            <TableCell><h6>Limited by</h6></TableCell>
                            <TableCell><h6>Date</h6></TableCell>
                            <TableCell><h6>TSN</h6></TableCell>
                            <TableCell><h6>CSN</h6></TableCell>
                            <TableCell><h6>EGTm</h6></TableCell>
                            <TableCell><h6>LLP limit</h6></TableCell>
                            <TableCell><h6>FC to PRSV</h6></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mp?.shop_visit_projections?.map((item, index) => (
                            <TableRow key={item?.id || item?.row_type}>
                                <TableCell>{item?.label}</TableCell>
                                <TableCell width='220'>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            disabled
                                            margin="normal"
                                            format={displayDateFormatShort}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            value={item?.projected_date || null}
                                            onChange={(date) => updateRow('shop_visit_projections', index, 'projected_date', date ? moment(date).format(backendDateFormat) : null)}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </TableCell>
                                <TableCell>
                                    <TextField disabled variant='outlined' fullWidth placeholder="Enter.." value={item?.projected_tsn || ''} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled variant='outlined' fullWidth placeholder="Enter.." value={item?.projected_csn || ''} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled variant='outlined' fullWidth placeholder="Enter.." value={item?.projected_egtm || ''} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled variant='outlined' fullWidth placeholder="Enter.." value={item?.projected_llp_limiter || ''} />
                                </TableCell>
                                <TableCell>
                                    <TextField disabled variant='outlined' fullWidth placeholder="Enter.." value={item?.fc_to_prsv || ''} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </section>
    );
}

export default withRouter(MaintenancePlanningV2);
